module.exports = __webpack_public_path__ + "media/img/frontend_application/visa-4c3a9037ad464b41ceb90308b3928f23.png";